import type { Point2, ReadableStore, Store } from '@frontend/viewer-core';

import type { SnapResolver } from './snapResolver';
import type { PointerState } from './types';
import { EMPTY_POINTER } from './types';

type Dependencies = {
  pointerStore: Store<PointerState>;
  resolve: SnapResolver;
};

export type PointerTracker = {
  /** Live tier: pointer position and snap target. */
  readonly store: ReadableStore<PointerState>;
  /** Resolves and publishes where the pointer is, or clears it on `null`. */
  setFrom(screenPoint: Point2 | null): void;
  reset(): void;
};

/** Owns the live pointer/snap store and the one function that ever writes to it. */
export const createPointerTracker = ({
  pointerStore,
  resolve,
}: Dependencies): PointerTracker => ({
  store: { getState: pointerStore.getState, subscribe: pointerStore.subscribe },

  setFrom(screenPoint) {
    pointerStore.setState(() =>
      screenPoint ? resolve(screenPoint) : EMPTY_POINTER,
    );
  },

  reset() {
    pointerStore.setState(() => EMPTY_POINTER);
  },
});
